module.exports = __webpack_public_path__ + "static/rule.d68479be.png";